import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import PrioritySelect from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/components/PrioritySelect';
import { ImageWithFallback } from 'components/desktop/_general/ImageWithFallback/ImageWithFallback';
import * as Product from 'types/Ingredient/Detail/OrderGuide/Product';

const ProductListItem = ({
	product,
	selectProduct,
	togglePriority,
}: {
	product: Product.Type;
	selectProduct: (product: Product.Type) => void;
	togglePriority: (input: { productId: string; sourceId: string; priority: number }) => void;
}) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div className={classes.productListItem}>
			<ImageWithFallback src={product.imageUrl} style={{ width: '50px', height: '50px' }} />
			<div className={classes.productListItemId}>{product.sourceId}</div>
			<PrioritySelect
				togglePriority={(priority) =>
					togglePriority({
						productId: product.productId,
						sourceId: product.sourceId,
						priority: priority,
					})
				}
				priority={product.priority}
			/>
			<div className={classes.productListItemName}>{product.name}</div>
			<div>
				<button className="btn btn-primary btn-sm" onClick={() => selectProduct(product)}>
					{t('_general:ADD')}
				</button>
			</div>
		</div>
	);
};

export const useStyles = tss.create({
	productListItem: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		border: '1px solid #ccc',
		marginTop: '-1px',
		padding: '5px',
		paddingRight: '10px',
		'&:hover': {
			backgroundColor: '#f0f0f0',
		},
	},
	productListItemId: {
		color: '#aaa',
		minWidth: '80px',
		borderRight: '1px solid #ccc',
		borderLeft: '1px solid #ccc',
		textAlign: 'center',
	},
	productListItemName: {
		flex: 1,
	},
});

export default ProductListItem;
